import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { filter, first } from 'rxjs';

import { getCatalogActions, selectCatalogsIsLoaded } from '../store';

export const loanResolver: ResolveFn<boolean> = () => {
  const store = inject(Store);
  store.dispatch(getCatalogActions.load());
  return store.pipe(select(selectCatalogsIsLoaded), filter(Boolean), first());
};
